//-------------------------------
// has missing combatant actions
//-------------------------------
export default function hasMissingCombatantActions(combatant, cur_action) {
  console.log("----------------------");
  console.log("IN hasMissingCombatantActions cur action = " + cur_action);
  let missing_cas = [];
  //----------------------------------------------
  // check previous cas for missing combat action
  //----------------------------------------------
  for (let i = 1; i < cur_action; i++) {
    let ca_type = "ca_type" + i;
    if (combatant[ca_type] != "action") {
      missing_cas.push(i);
    }
  }
  return missing_cas;
}
